/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1IjoiZmluZ2Rlc2t0b3AiLCJhIjoiY2s2dWt2Z3ltMDA4MDNocXVia2tsem05ZyJ9.FAkWg0Ym3IGG0RsOBthDVQ';
// mapboxgl.accessToken = 'pk.eyJ1IjoibXNsZWUiLCJhIjoiclpiTWV5SSJ9.P_h8r37vD8jpIH1A6i1VRg';

export default class OutageMap extends Component {

    componentDidMount() {
        this.initMap();
    }

    componentDidUpdate() {
        this.initMap();
    }

    initMap() {

        const outages = this.props.outages;

        let nowDate = new Date();
        let dataPoints = [];
        // let totalArea = 0;
        let maxIntensity = 0;
        let newGeoJson = {
            type: "FeatureCollection",
            features: [

            ]
        };

        let setForCenter = [];

        const drillFn = (drill, metric, liveMetric) => {
            let dataPoint = [drill.latitude, drill.longitude, drill.intensity];
            if (dataPoint) {
                dataPoint[2] = dataPoint[2] * metric * liveMetric;
                dataPoints.push(dataPoint);
                maxIntensity = Math.max(dataPoint[2], maxIntensity);
            }

            newGeoJson.features.push({
                type: "Feature",
                properties: {
                    dbh: dataPoint[2]
                },
                geometry: {
                    type: "Point",
                    coordinates: [dataPoint[1], dataPoint[0]]
                }
            })


            setForCenter.push({ lngLat: [dataPoint[1], dataPoint[0]] })

        };

        for (let i = 0; i < outages.length; i++) {
            const outage = outages[i];

            if (this.props.durationMetric) {
                if ((nowDate.getTime() - outage.endTime) > 60000 * 60 * 24 * 17) continue;
                if (!outage.mainDimensionIspValue) continue;

                let durationMetric = Math.max(1, 1 / ((nowDate.getTime() - outage.endTime) / 300000));
                outage.topGeoHashDrills.forEach(drill => drillFn(drill, durationMetric));
            } else {

                const countryImpact = (outage.parentImpactPerc > 0 ? outage.parentImpactPerc : outage.impactPerc) / 10;
                let liveMetric = 1;
                if (this.props.live) liveMetric = outage.active ? 1.0 : (0.50 * Math.min(1, 1 / ((nowDate.getTime() - outage.endTime) / 300000)));

                outage.topGeoHashDrills.forEach(drill => drillFn(drill, countryImpact, liveMetric));
            }

        }


        const findMapCenterByPoints = (points) => {
            let latitude = 0;
            let longitude = 0;
            let size = points.length;

            for (let point of points) {
                longitude += point.lngLat[0];
                latitude += point.lngLat[1];
            }

            return [longitude / size, latitude / size];
        }

        const map = new mapboxgl.Map({
            container: this.mapContainer,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: findMapCenterByPoints(setForCenter),
            zoom: this.props.zoom || 4,
            minZoom: 1,
            maxZoom: this.props.zoom ? 22 : 4 //if zoom is passed there isn't a max ... if zoom is 4 max is 4 
        });

        map.scrollZoom.disable();

        if (!this.props.live) {
            map.addControl(new mapboxgl.NavigationControl());
        }

        if (map.getSource('outages')) map.removeSource('outages');

        console.log('newGeo', newGeoJson);

        map.on('load', function () {

            map.addSource('outages', {
                type: 'geojson',
                data: newGeoJson
            });

            map.addLayer({
                id: 'outages-heat',
                type: 'heatmap',
                source: 'outages',
                maxzoom: 15,
                paint: {
                    // increase weight as diameter breast height increases
                    'heatmap-weight': {
                        property: 'dbh',
                        type: 'exponential',
                        stops: [
                            [1, 0],
                            [62, 1]
                        ]
                    },
                    // increase intensity as zoom level increases
                    'heatmap-intensity': {
                        stops: [
                            [11, 1],
                            [15, 3]
                        ]
                    },
                    // assign color values be applied to points depending on their density
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0, 'rgba(236,222,239,0)',
                        // 0.05, '#F6E017',
                        0.02, '#F6E017',
                        0.06, '#f6db02',
                        0.07, '#f6db02',
                        0.08, '#f6db02',
                        0.09, '#f6c503',
                        0.1, '#f6c503',
                        0.2, '#f6c503',
                        0.4, '#ff9933',
                        0.6, '#ff8000',
                        0.8, '#F38201',
                        1.0, '#f53301'
                    ],
                    // increase radius as zoom increases
                    'heatmap-radius': {
                        stops: [
                            [11, 15],
                            [12, 17]
                        ]
                    },
                    // decrease opacity to transition into the circle layer
                    'heatmap-opacity': {
                        default: 1,
                        stops: [
                            [14, 1],
                            [15, 0]
                        ]
                    },
                }
            }, 'waterway-label');

            // add circle layer here
        });

    }

    render() {

        return (
            <div style={{height: this.props.height}}>
                <div ref={el => this.mapContainer = el} className="mapContainer rounded" />
            </div>
        )
    }

}